// test1201
(1201 && 0);
